import Layout from "@/layouts"
import {i18n} from "@/utils/i18n";

const settingsCategory = {
  path: "/settings-category",
  component: Layout,
  name: "settingsCategory",
  redirect: "/settings-category/index",

  children: [
    {
      path: "/settings-category/index",
      component: () => import("@/views/settingsCategory/index"),
      name: "settingsCategory.index",
      meta: { title: "settings Category" },
    },
    {
      path: "",
      component: () => import("@/views/settingsCategory/_slug"),
      name: "settingsCategory.slug",
      meta: { title: "slug" },
      children: [
        {
          path: "/settings-category/workTimes/index",
          component: () => import("@/views/workTime/index"),
          name: "workTimes", //.index
          meta: { title: i18n.t(`message.workTime`) },
        },
        {
          path: "/settings-category/bunk/departments",
          component: () => import("@/views/bunk/departments"),
          name: "bunk_departments",
          meta: { title: i18n.t(`message.branches`) },
        },
        {
          path: "/settings-category/specialties/index",
          component: () => import("@/views/specialty/index"),
          name: "specialties", //.index
          meta: { title: i18n.t(`message.specialties`) },
        },
        {
          path: "/settings-category/rooms/index",
          component: () => import("@/views/rooms/index"),
          name: "rooms", //.index
          meta: { title: i18n.t(`message.rooms`) },
        },
        {
          path: "/settings-category/services/index",
          component: () => import("@/views/service/index"),
          name: "service", //.index
          meta: { title: i18n.t(`message.service`) },
        },
        {
          path: "/settings-category/partnerDoctor/index",
          component: () => import("@/views/partnerDoctor/index"),
          name: "partnerDoctor", //.index
          meta: { title: i18n.t(`message.partner_doctor`) },
        },
        {
          path: "/settings-category/partnerClinic/index",
          component: () => import("@/views/partnerClinic/index"),
          name: "partnerClinic", //.index
          meta: { title: i18n.t(`message.partner_clinic`) },
        },
        {
          path: "/settings-category/ownerBranch/index",
          component: () => import("@/views/ownerBranch/index"),
          name: "ownerBranch", //.index
          meta: { title: i18n.t(`message.departments`) },
        },
        {
          path: "/settings-category/couriers/index",
          component: () => import("@/views/couriers/index"),
          name: "couriers", //.index
          meta: { title: i18n.t(`message.couriers`) },
        },
        {
          path: "/settings-category/insuranceCompany/index",
          component: () => import("@/views/insuranceCompany/index"),
          name: "insuranceCompany", //.index
          meta: { title: i18n.t(`message.invoice_companies`) },
        },
        {
          path: "/settings-category/ProductsWarehouses/index",
          component: () => import("@/views/ProductsWarehouses/index"),
          name: "productsWarehouses",
          meta: { title: i18n.t(`message.products`) }
        },
        {
          path: "/settings-category/stocksSryaWarehouses/index",
          component: () => import("@/views/stocksSryaWarehouses/index"),
          name: "stocksSryaWarehouses",
          meta: { title: i18n.t(`message.warehouses`) }
        },
        {
          path: "/settings-category/warehouseProvider/index",
          component: () => import("@/views/warehouseProvider/index"),
          name: "warehouseProvider",
          meta: { title: i18n.t(`message.suppliers`) }
        },
        {
          path: "/settings-category/currencies/index",
          component: () => import("@/views/currency/index"),
          name: "currencies", //.index
          meta: { title: i18n.t(`message.currencies`) },
        },
        {
          path: "/settings-category/currenciesWarehouses/index",
          component: () => import("@/views/currenciesWarehouses/index"),
          name: "currenciesWarehouses", //.index
          meta: { title: i18n.t(`message.types_currencies`) },
        },
        {
          path: "/settings-category/groupsWarehouses/index",
          component: () => import("@/views/groupsWarehouses/index"),
          name: "groupsWarehouses.index",
          meta: {title: i18n.t(`message.group_types`),},
        },
        {
          path: "/settings-category/measurementsWarehouses/index",
          component: () => import("@/views/measurement/index"),
          name: "measurementsWarehouses", //.index
          meta: { title: i18n.t(`message.measurements`) },
        },
        {
          path: "/settings-category/paymentTypes/index",
          component: () => import("@/views/paymentType/index"),
          name: "paymentTypes", //.index
          meta: { title: i18n.t(`message.payment_type`) },
        },
        {
          path: "/settings-category/ownerClinic/index",
          component: () => import("@/views/ownerClinic/index"),
          name: "ownerClinic", //.index
          meta: { title: i18n.t(`message.owner_clinic`) },
        },
        {
          path: "/settings-category/promotions/index",
          component: () => import("@/views/promotions/index"),
          name: "promotions", //.index
          meta: { title: i18n.t(`message.promotions`) },
        },
        {
          path: "/settings-category/orderColumn/index",
          component: () => import("@/views/orderColumn/index"),
          name: "orderColumn", //.index
          meta: { title: i18n.t(`message.order_attributes`) },
        },
        {
          path: '/settings-category/excelColumns/index',
          component: () => import('@/views/excelColumns/index'),
          name: 'excelColumns.index',
          meta: { title: 'Excel' }
        },
        {
          path: '/settings-category/categoryServices/index',
          component: () => import('@/views/categoryService/index'),
          name: 'categoryServices.index',
          meta: { title: i18n.t(`message.service_types`) }
        },
        {
          path: "/settings-category/hours/index",
          component: () => import("@/views/hour/index"),
          name: "hours", //.index
          meta: { title: i18n.t(`message.time`) },
        },
        {
          path: "/settings-category/conditions/index",
          component: () => import("@/views/condition/index"),
          name: "conditions", //.index
          meta: { title: i18n.t(`message.condition`) },
        },
        {
          path: "/settings-category/states/index",
          component: () => import("@/views/state/index"),
          name: "states", //.index
          meta: { title: i18n.t(`message.countries`) },
        },
        {
          path: "/settings-category/statuses/index",
          component: () => import("@/views/status/index"),
          name: "statuses", //.index
          meta: { title: i18n.t(`message.status`) },
        },
        {
          path: "/settings-category/region/index",
          component: () => import("@/views/region/index"),
          name: "region", //.index
          meta: { title: i18n.t(`message.region`) },
        },
        {
          path: "/settings-category/cities/index",
          component: () => import("@/views/city/index"),
          name: "cities", //.index
          meta: { title: i18n.t(`message.cities`) },
        },
        {
          path: "/settings-category/district/index",
          component: () => import("@/views/district/index"),
          name: "district", //.index
          meta: { title: i18n.t(`message.district`) },
        },
        {
          path: "/settings-category/formLogo/index",
          component: () => import("@/views/formLogo/index"),
          name: "formLogo", //.index
          meta: { title: i18n.t(`message.graphic`) },
        },
        {
          path: "/settings-category/discountPatient/index",
          component: () => import("@/views/discountPatient/index"),
          name: "discountPatient", //.index
          meta: { title: i18n.t(`message.discountPatients`) },
        },
        {
          path: "/settings-category/express/index",
          component: () => import("@/views/express/index"),
          name: "express", //.index
          meta: { title: i18n.t(`message.express`) },
        },
        {
          path: "/settings-category/process/index",
          component: () => import("@/views/process/index"),
          name: "process", //.index
          meta: { title: i18n.t(`message.process`) },
        },
        {
          path: "/settings-category/department/index",
          component: () => import("@/views/department/index"),
          name: "department", //.index
          meta: { title: i18n.t(`message.department`) },
        },
        {
          path: "/settings-category/material/index",
          component: () => import("@/views/material/index"),
          name: "material", //.index
          meta: { title: i18n.t(`message.material`) },
        },
        {
          path: "/settings-category/sickNumber/index",
          component: () => import("@/views/sickNumber/index"),
          name: "sickNumber", //.index
          meta: { title: i18n.t(`message.sickNumber`) },
        },
        {
          path: "/settings-category/doctorSign/index",
          component: () => import("@/views/doctorSign/index"),
          name: "doctorSign", //.index
          meta: { title: i18n.t(`message.doctorSigns`) },
        },
        {
          path: "/settings-category/socials/index",
          component: () => import("@/views/social/index"),
          name: "socials", //.index
          meta: { title: i18n.t(`message.source`) },
        },
        {
          path: "/settings-category/costs/index",
          component: () => import("@/views/cost/index"),
          name: "costs", //.index
          meta: { title: i18n.t(`message.flow_types`) },
        },
        {
          path: "/settings-category/documentations/index",
          component: () => import("@/views/settings/documentations/index"),
          name: "documentationList",
          meta: { title: i18n.t(`message.conclusion_templates`) },
        },
        {
          path: "/settings-category/categoryFormTemplates/index",
          component: () => import("@/views/settings/categoryFormTemplates/index"),
          name: "categoryFormTemplates",
          meta: { title: i18n.t(`message.category_templates`) },
        },
        {
          path: "/settings-category/printAudit",
          component: () => import("@/views/printAuditable/index"),
          name: "printAudit.index",
          meta: { title: i18n.t(`message.cities`) },
        },
        {
          path: "/settings-category/permissions/index",
          component: () => import("@/views/permissions/index"),
          name: "permissions.index",
          meta: { title: i18n.t(`message.permissions`) },
        },
        {
          path: "/settings-category/roles/index",
          component: () => import("@/views/roles/index"),
          name: "roles.index",
          meta: { title: i18n.t(`message.roles`) },

        },
        {
          path: "/settings-category/users/index",
          component: () => import("@/views/users/index"),
          name: "users.index",
          meta: { title: i18n.t(`message.users`) },
        },
      ],
    },
  ],
}

export default settingsCategory
